"use client";

import * as React from "react";
import { cn } from "@/lib/cn";

function onlyDigits(v: string) {
  return v.replace(/\D/g, "");
}

function formatCardNumber(v: string) {
  const d = onlyDigits(v).slice(0, 16);
  const padded = (d + "•".repeat(16)).slice(0, 16);
  return padded.replace(/(.{4})/g, "$1 ").trim();
}

function formatExpiry(v: string) {
  const d = onlyDigits(v).slice(0, 4);
  const mm = (d + "MM").slice(0, 2);
  const yy = (d.slice(2) + "AA").slice(0, 2);
  return `${mm}/${yy}`;
}

export function CardPreview({
  number,
  name,
  expiry,
  cvv,
  flipped
}: {
  number: string;
  name: string;
  expiry: string;
  cvv: string;
  flipped: boolean;
}) {
  const safeName = (name || "SEU NOME AQUI").toUpperCase().slice(0, 26);
  const cvvMasked = "*".repeat(Math.min(4, onlyDigits(cvv).length || 3));

  return (
    <div style={{ perspective: 1000 }}>
      <div
        className={cn("cardFlip", flipped ? "cardFlipFlipped" : "")}
        style={{
          position: "relative",
          width: "100%",
          maxWidth: 440,
          aspectRatio: "16 / 10",
          margin: "0 auto"
        }}
      >
        {/* FRONT */}
        <div
          className="cardFace"
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 18,
            padding: 18,
            background:
              "radial-gradient(420px 220px at 20% 0%, rgba(22,163,74,0.35), transparent 60%), radial-gradient(420px 220px at 90% 100%, rgba(15,23,42,0.16), transparent 55%), linear-gradient(135deg, #0f172a, #111827)",
            color: "#fff",
            boxShadow: "0 22px 40px rgba(15,23,42,0.22)",
            backfaceVisibility: "hidden",
            transform: "rotateY(0deg)"
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontWeight: 950, letterSpacing: 0.6, opacity: 0.9 }}>SPCERTIFICADO</div>
            <div style={{ width: 46, height: 30, borderRadius: 10, background: "rgba(255,255,255,0.12)" }} />
          </div>

          <div style={{ marginTop: 34, fontSize: 20, letterSpacing: 2.2, fontWeight: 900 }}>
            {formatCardNumber(number)}
          </div>

          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 26, gap: 10 }}>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 10, opacity: 0.7, letterSpacing: 1.2, fontWeight: 900 }}>TITULAR</div>
              <div style={{ fontWeight: 900, marginTop: 6, fontSize: 13, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                {safeName}
              </div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontSize: 10, opacity: 0.7, letterSpacing: 1.2, fontWeight: 900 }}>VALIDADE</div>
              <div style={{ fontWeight: 950, marginTop: 6, fontSize: 13 }}>{formatExpiry(expiry)}</div>
            </div>
          </div>
        </div>

        {/* BACK */}
        <div
          className="cardFace"
          style={{
            position: "absolute",
            inset: 0,
            borderRadius: 18,
            padding: 18,
            background: "linear-gradient(135deg, #0f172a, #111827)",
            color: "#fff",
            boxShadow: "0 22px 40px rgba(15,23,42,0.22)",
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)"
          }}
        >
          <div style={{ height: 44, background: "rgba(0,0,0,0.55)", borderRadius: 10 }} />
          <div style={{ marginTop: 18, display: "flex", justifyContent: "flex-end" }}>
            <div style={{ width: "62%", background: "rgba(255,255,255,0.12)", borderRadius: 10, padding: "10px 12px" }}>
              <div style={{ fontSize: 10, opacity: 0.8, fontWeight: 900, letterSpacing: 1.2 }}>CVV</div>
              <div style={{ marginTop: 6, fontWeight: 950, letterSpacing: 3 }}>{cvvMasked}</div>
            </div>
          </div>
          <div style={{ marginTop: 18, fontSize: 10, opacity: 0.7, fontWeight: 900, letterSpacing: 1.2 }}>
            Pagamento processado em ambiente seguro.
          </div>
        </div>
      </div>
    </div>
  );
}

